import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HubspotAuthService {
   private baseUrl = `${environment.apiUrl}${environment.apiEndpoint}/hubspot`;
  constructor(private http: HttpClient) {}

  loginWithHubspot(username: string, password: string): Observable<{ auth_url: string }> {
    const body = new URLSearchParams();
    body.set('username', username);
    body.set('password', password);

    return this.http.post<{ auth_url: string }>(
      `${this.baseUrl}/hubspot_login`,
      body.toString(),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    );
  }
}
